<template lang="pug">
  ul.social-links
    li.social-links__icon(v-for="icon in icons" v-in-viewport.once="true")
      a(:href="icon.url" target="_blank" rel="noopener" aria-label="icon.name")
        svg.svgicon
          use(xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#icon-' + icon.name")
</template>


<script>
  export default {
    name: 'SocialNetworks',

    data: () => ({
      icons: [
        { name: 'twitter', url: 'https://twitter.com/whois_jorge' },
        { name: 'github', url: 'https://github.com/whoisjorge' },
        { name: 'codepen', url: 'https://www.codepen.io/whoisjorge' },
        { name: 'linkedin', url: '#' }
        // { name: 'mail', url: 'mailto:email@whoisjorge.me' }
      ]
    })
  }
</script>


<style lang="sass" scoped>
  .social-links
    display: flex
    justify-content: flex-start
    list-style: none
    margin-bottom: 4rem
    +breakpoint(lg)
      margin-bottom: 0
    &__icon
      font-size: .8rem
      display: inline-block
      margin: 0 16px
      opacity: 0
      +breakpoint(sm)
        font-size: 1rem
        margin: 0 20px
      +breakpoint(md)
        margin: 0 24px
        font-size: 1.25rem
      &:first-child
        margin-left: 2.5rem
        +breakpoint(lg)
          margin-left: 24px
      // Animation
      @for $i from 1 through 5
        &:nth-of-type(#{$i})
          &.in-viewport
            animation: (0.5s + ($i - 1) * 0.1s) fadeInUp (10ms + ($i - 1) * 0.1s) both

    .svgicon
      fill: #fafafa
</style>



// WEBPACK FOOTER //
// src/components/SocialNetworks.vue